"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const WrongP = styled_1.default.p `
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  font-size: 30px;
  text-align: center;
`;
const Details = styled_1.default.details `
  margin-top: 10px;
  white-space: pre-wrap;
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  color: red;
`;
function ErrorOverlay(props) {
    return ((0, jsx_runtime_1.jsxs)("div", { style: { margin: 25 }, children: [(0, jsx_runtime_1.jsx)(WrongP, { children: "Something went wrong." }), (0, jsx_runtime_1.jsxs)(Details, { children: [(0, jsx_runtime_1.jsx)("p", { style: { textDecoration: 'underline' }, children: props.error.message }), props.error.stack] })] }));
}
exports.default = ErrorOverlay;
